import type { TBulkRegisterChannelEntry } from 'types';

const BASIC_ID_COLUMN = 'basic_id';
const CHANNEL_ID_COLUMN = 'channel_id';
const CHANNEL_SECRET_COLUMN = 'channel_secret';

function parseColumns(line: string) {
  return line.split(',').map((column) => column.trim());
}

function resolveColumnIndexes(columns: string[]) {
  const normalizedColumns = columns.map((column) => column.toLowerCase());
  const basicIdIndex = normalizedColumns.indexOf(BASIC_ID_COLUMN);
  const channelIdIndex = normalizedColumns.indexOf(CHANNEL_ID_COLUMN);
  const channelSecretIndex = normalizedColumns.indexOf(CHANNEL_SECRET_COLUMN);

  if (basicIdIndex !== -1 && channelIdIndex !== -1 && channelSecretIndex !== -1) {
    return {
      hasHeader: true,
      basicIdIndex,
      channelIdIndex,
      channelSecretIndex,
    };
  }

  return {
    hasHeader: false,
    basicIdIndex: 0,
    channelIdIndex: 1,
    channelSecretIndex: 2,
  };
}

export function parseChannelCrawlCsv(text: string): TBulkRegisterChannelEntry[] {
  const lines = text.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length === 0) return [];

  const firstLineColumns = parseColumns(lines[0]);
  const {
    hasHeader,
    basicIdIndex,
    channelIdIndex,
    channelSecretIndex,
  } = resolveColumnIndexes(firstLineColumns);
  const dataLines = hasHeader ? lines.slice(1) : lines;

  return dataLines.map((line) => {
    const columns = parseColumns(line);

    return {
      basic_id: columns[basicIdIndex] ?? '',
      channel_id: columns[channelIdIndex] ?? '',
      channel_secret: columns[channelSecretIndex] ?? '',
    };
  });
}
